export { default } from './TypologyGuide';
